export default "__VITE_ASSET__15yy4Y_L__"